import type { ReactNode, SVGProps } from "react";

export function CalendarIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 12 14"
			width="12"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.600098 3.26668C0.600098 2.91306 0.731794 2.57392 0.966214 2.32387C1.20063 2.07383 1.51858 1.93335 1.8501 1.93335H9.3501C9.68162 1.93335 9.99956 2.07383 10.234 2.32387C10.4684 2.57392 10.6001 2.91306 10.6001 3.26668V11.2667C10.6001 11.6203 10.4684 11.9594 10.234 12.2095C9.99956 12.4595 9.68162 12.6 9.3501 12.6H1.8501C1.51858 12.6 1.20063 12.4595 0.966214 12.2095C0.731794 11.9594 0.600098 11.6203 0.600098 11.2667V3.26668Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M8.1001 0.600098V3.26676"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M3.1001 0.600098V3.26676"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.600098 5.93335H10.6001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M4.9751 8.6001H5.6001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M5.6001 8.6001V10.6001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
